module.exports = __webpack_public_path__ + "img/status-solid-lock.841dfe2d.svg";